"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toArray"));
var _ykbUtils = require("ykb-utils");
var _Helpers = require("../Helpers");
var isCheckFilteredValue = function isCheckFilteredValue(original, columnId, filterValues) {
  if ((0, _ykbUtils.isNullOrUndefined)(original[columnId])) return false;
  var valueToSearch = String(original[columnId]) || '';
  return filterValues.some(function (value) {
    return valueToSearch.toUpperCase() === value.toUpperCase();
  });
};
var searchableFilter = function searchableFilter(row, filterValues) {
  /**
   *
   * Burada filtre işlemi kontrolleri yapılacak. Buradaki kontrollerin sonucunda satırlar gizlenecek.
   *
   */

  var _filterValues = (0, _toArray2.default)(filterValues),
    _ = _filterValues[0],
    props = _filterValues[1],
    column = _filterValues[2],
    values = _filterValues.slice(3);
  var filteredValue = column.filteredValue || column.dataIndex;
  var value = values[0];
  var exist = isCheckFilteredValue(row, filteredValue, value);
  /**
   * exist;
   * true  => göster
   * false => gizle
   */
  // let nestedExist = false;
  // if (!exist && Array.isArray(row.children)) {
  //   const list = Utils.flatten(row.children);
  //   nestedExist = list.some(item =>
  //     isCheckFilteredValue(item, filteredValue, value)
  //   );
  // }

  // const isExpanded = row.getIsExpanded();
  // const returnVal = exist || nestedExist;
  // if (nestedExist && !isExpanded) {
  //   // const handleExpand = row.getToggleExpandedHandler();
  //   handleExpand();

  //   // const filterData = Object.assign(row.original, { rowId: row.id });
  //   // props?.onExpandByFilter && props.onExpandByFilter(filterData);
  // }
  return exist;
};
var _default = exports.default = searchableFilter;